import React from 'react';
import logo from "@assets/svg/logo.svg";
import Lottie from "react-lottie";
import serviceUnavailable from "@assets/animations/service_unavailable.json";
import {useTranslation} from "react-i18next";

const ServiceUnavailable = () => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-center justify-center align-middle'>
      <img alt="logo" className="mt-10 h-10" src={logo}/>
      <div className="rounded-md text-center mt-2">
        <h1 className="text-3xl font-bold text-gray-900 sm:text-2xl xs:text-xl">
          {t('weWereNotAbleToCompleteYourOrderProcess')}.
        </h1>
        <div className="mt-15 justify-around align-middle mx-9">
          <Lottie
            height={300}
            width={300}
            options={{
              loop: true,
              autoplay: true,
              animationData: serviceUnavailable,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
          />
          <p className="w-full my-5 font-normal text-md text-gray-600">
            {t('theProvidedQrIsInvalid')}. {t("pleaseTryAgainWhenVisitingOurBusiness")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceUnavailable;
